import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

/**
 * Белая r12 панель, из которой собран каждый экран: паддинг 20 на десктопе,
 * 16 на мобильном, рамки нет и тени практически нет — от канвы отделяет заливка.
 * Карточки не вкладываются друг в друга: внутри карточки живёт SunkenPanel.
 */
const cardVariants = cva("flex flex-col rounded-card bg-card", {
	variants: {
		padding: {
			none: "",
			desktop: "p-5",
			mobile: "p-4",
			auth: "p-8",
			/** Список во всю ширину карточки: горизонтальный паддинг есть, вертикальный съеден строками. */
			list: "px-4 py-2",
		},
		gap: {
			none: "",
			tight: "gap-2.5",
			row: "gap-3.5",
			default: "gap-5",
			wide: "gap-8",
		},
		floating: { true: "shadow-float", false: "" },
	},
	defaultVariants: { padding: "desktop", gap: "default", floating: false },
});

export interface CardProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof cardVariants> {
	children?: ReactNode;
}

export function Card({ padding, gap, floating, className, children, ...rest }: CardProps) {
	return (
		<section className={cn(cardVariants({ padding, gap, floating }), className)} {...rest}>
			{children}
		</section>
	);
}

export { cardVariants };
